<template>
  <div class="levo__dole__how">
    <div class="pointer" @click="$emit('leave')">
      <div class="levo__dole__how__button">
        <div class="levo__dole__how__button--img"></div>
      </div>
      <div class="levo__dole__how__text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LevoHowTo",
  props: {
    text: String,
  },
};
</script>
